// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.container {
    max-width: 1200px;
    margin: auto;
    width: 100%;
}

/* Card Header */
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* Goal Item */
.goal {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 10px;
}

/* Task Item */
.task-item {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 10px;
}

.task-details {
    display: flex;
    align-items: center;
    width: 100%;
}

.task-name {
    flex-grow: 1;
    margin-right: 1rem;
}

.task-category {
    flex: 0 1 200px;
    margin-bottom: 0;
}

.task-expected-time {
    width: 100px;
    margin-bottom: 0;
    text-align: center;
}

.task-actions {
    display: flex;
    align-items: center;
}

/* Input Group */
.input-group {
    display: flex;
    align-items: center;
}

.input-group .form-control {
    flex: 1 1;
}

/* Margin Utilities */
.me-2 {
    margin-right: 0.5rem;
}

/* Progress */
.progress {
    height: 20px;
    margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/GoalManager.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,SAAO;AACX;;AAEA,qBAAqB;AACrB;IACI,oBAAoB;AACxB;;AAEA,aAAa;AACb;IACI,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":["/* Container */\r\n.container {\r\n    max-width: 1200px;\r\n    margin: auto;\r\n    width: 100%;\r\n}\r\n\r\n/* Card Header */\r\n.card-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n/* Goal Item */\r\n.goal {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n/* Task Item */\r\n.task-item {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.task-details {\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n\r\n.task-name {\r\n    flex-grow: 1;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.task-category {\r\n    flex: 0 1 200px;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.task-expected-time {\r\n    width: 100px;\r\n    margin-bottom: 0;\r\n    text-align: center;\r\n}\r\n\r\n.task-actions {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n/* Input Group */\r\n.input-group {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.input-group .form-control {\r\n    flex: 1;\r\n}\r\n\r\n/* Margin Utilities */\r\n.me-2 {\r\n    margin-right: 0.5rem;\r\n}\r\n\r\n/* Progress */\r\n.progress {\r\n    height: 20px;\r\n    margin-top: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
